<template>
	<div id="news-preview" class="page">
		<h3 class="titles">
			新聞に間違いがないか確認しよう
		</h3>
		<ul class="news-preview-step">
			<li>
				１　新聞の名前、日付、発行者は記入しましたか？　間違いはありませんか？<br/>
				２　見出し、本文記事、絵解きをもう一度読み返してみましょう。<br/>
				３　写真は正しくアップされていますか？<br/>
				４　人名、地名、学校名などの固有名詞は正しいですか？　<br/>
				５　日付や数字などのデータは合っていますか？<br/>
				６　誤字脱字、変換ミスはありませんか？<br/>
				７　お疲れ様でした！　すべてチェックできたらダウンロード！<br/>
			</li>
		</ul>

		<div class="container" v-if="item">
			<section id="layout">
				<div class="preview"
						 v-if="!output"
						 :class="{'opacity-0': isMobileDevice}"
				>
					<div class="container scalable" id="preview">
						<div id="preview-page">
							<div class="layout-header preview-header">
								<!-- header date-->
								<div class="layout-header-date">
									<div class="layout-header-date-wrap">
										<div class="layout-header-date-text">
											<p>{{item.date}}</p>
										</div>
									</div>
								</div>

								<div class="layout-header-brand">
									<div id="logoHeader">
										<div id="logoLeftHeader" class="left">
											<span v-text="'新聞'"/>
										</div>

										<div id="logoRightHeader" class="right">
											<span :class="classBinding" v-text="item.logo"/>
										</div>
									</div>
								</div>

								<div class="layout-header-info">
									<div class="layout-header-info-wrap">
										<div class="layout-header-info-text">
											<p class="text-horizontal" v-html="item.issuer"></p>
										</div>
									</div>
								</div>
							</div>

							<FormPreview/>
						</div>

						<div class="footer-text">
							産経新聞社提供『かんたん号外くん』
						</div>
					</div>
				</div>
			</section>

			<div class="image-output" v-if="output">
				<img :src="output" width="100%" height="auto">
			</div>

			<section id="button" class="btn btn-row btn-function">
				<a href="#" class="btn-red" id="btn-pdf" @click.prevent="handleDownload('pdf')">PDFとしてダウンロード</a>
				<a href="#" class="btn-blue" id="btn-image" @click.prevent="handleDownload('image')">画像としてダウンロード</a>
			</section>
			<section class="share">
				<h3>作った新聞をダウンロードしたり、シェアしよう</h3>
			</section>

			<section id="buttonBottom" class="btn btn-row">
				<a href="#" id="goBack" class="btn-blue" @click.prevent="$router.push('create')">新聞を作るページに戻る</a>

				<router-link class="btn-section-blue" to="/introduction">
					トップに戻る
				</router-link>
			</section>
		</div>

		<div class="loading" :class="{'active': loading}">
			<div class="loading__inner">
				<svg class="loading__spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	// import component
	import FormPreview from '../../components/newspaper/FormPreview'
	import NewspaperMixin from '../../mixins/newspaper.mixin'
	import DownloadMixin from '../../mixins/download.mixin'
	// supporter
	import defaultLogo from '../../assets/img/logos/logo-sankei-main.png'
	import NewspaperModel from '../../models/newspaper.model'
	import { removeHtml } from '../../utils/helper'
	// lib
	import html2canvas from 'html2canvas'
	import moment from 'moment'
	import { isIOS, isSafari, isFirefox, isChrome, isMobile, isAndroid } from 'mobile-device-detect'

	export default {
		/**
		 * Set Meta for SEO & Facebook
		 */
		metaInfo: {
			meta: [
				{ charset: 'utf-8' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name: 'description', content: 'bar' },
				{ property: 'og:url', content: 'https://www.sankei.com/nie/create-newspaper.html' },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:title', content: '産経新聞・新聞アプリ' },
				{ property: 'og:description', content: '産経新聞の教育ページ。簡単にオリジナルの新聞を作ることが出来ます。' },
				{ property: 'og:image', content: 'https://www.sankei.com/common/images/v1/news_ogp.png' }
			],
			title: 'Sankei Shinbun',
			htmlAttrs: {
				lang: 'en',
				amp: true
			}
		},

		name: 'NewspaperPreview',

		components: { FormPreview },

		data () {
			return {
				output: '',
				logoUrl: defaultLogo,
				urlSite: 'https://www.sankei.com/nie/create-newspaper.html',
				fbTitle: '産経新聞・新聞アプリ',
				fbDescription: '産経新聞の教育ページ。簡単にオリジナルの新聞を作ることが出来ます。',
				styleForExport: {
					'transform': 'scale(1)',
					'transform-origin': 'top left'
				},
				loading: false
			}
		},

		mixins: [
			NewspaperMixin('preview'),
			DownloadMixin
		],

		computed: {
			/**
			 * get data from input
			 */
			item () {
				return NewspaperModel.query().find(1)
			},

			/**
			 * create file name
			 */
			fileDownloadName () {
				const headline = this.item.headline && this.item.headline !== '<br>' ? this.item.headline : ''
				return (headline || moment(new Date()).format('YYYY年MM月DD日'))
			},

			/**
			 * Class for logo
			 *
			 */
			classBinding () {
				if (!this.item.logo) {
					return 'one'
				}

				switch (removeHtml(this.item.logo).length) {
					case 1:
						return 'one'
						break
					case 2:
						return 'two'
						break
					case 3:
						return 'three'
						break
					default:
						return 'four'
						break
				}
			},

			/**
			 * Detach is mobile
			 * @return boolean
			 */
			isMobileDevice () {
				return window.innerWidth < 1025
			},

			/**
			 * Safari
			 */
			isSafariBrowser () {
				return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
						navigator.userAgent &&
						navigator.userAgent.indexOf('CriOS') === -1 &&
						navigator.userAgent.indexOf('FxiOS') === -1
			}
		},

		created () {
			// redirect to create page if null item
			if (!this.item) this.$router.push({ name: 'Newspaper' })

			this.item.logo = this.limitString(this.removeHTML(this.item.logo), 4)
		},

		beforeRouteLeave (to, from, next) {
			if (this.item) {
				this.removeSectionString('content')
				this.removeSectionString('lead_sentence')
				this.removeSectionString('article_title')
				this.removeSectionString('sleeve_title')
			}

			next()
		},

		mounted () {
			this.$nextTick(() => {
				if (this.isMobileDevice || isSafari) {
					this.handleSpecialCharacterForMobile()
				}

				if (this.isMobileDevice) {
					this.renderOutput()
				} else {
					this.handleMainTitlePosition()
				}
			})
		},

		methods: {
			limitString (value, maxLength = 10) {
				return value.substr(0, maxLength)
			},
			/**
			 *
			 */
			handleDownload (type = 'image') {
				this.loading = true
				const ID = document.getElementById('preview')
				if (this.isMobileDevice) {
					this.handleDownloadMobile(type)
				} else {
					this.handleDownloadDesktop(ID, type)
				}
			},

			/**
			 * Render Layout to Image Base64
			 */
			renderOutput () {
				let self = this
				self.loading = true

				this.$nextTick(() => {
					const ID = document.getElementById('preview')

					//Get preview position to render image
					let YPos = ID.offsetTop
					let xPos = ID.offsetLeft

					// set main title position
					this.handleMainTitlePosition()
					// set Logo
					this.handleLogoPosition()
					// set Sub Headline
					this.handleSubHeadline()

					let startRender = new Date().getTime()

					html2canvas(ID, {
						// logging: true,
						imageTimeout: 0,
						allowTaint: true,
						x: xPos,
						y: YPos,
						scrollX: 0,
						scrollY: 0,
						scale: 3
					}).then(canvas => {
						self.output = canvas.toDataURL('image/jpeg')
					}).then(() => {
						self.loading = false

						let endRender = new Date().getTime()
						console.log('Execution time: ' + (endRender - startRender))
					}).catch(() => self.loading = false)
				})
			},

			/**
			 * Popup window when click share
			 */
			popUpShare (URL) {
				let window_size = `width=600,height=500,top=${ screen.height / 2 - 250 },left=${ screen.width / 2 - 300 }`

				window.open(URL, '_blank',
						'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,' +
						window_size)
				return false
			},

			/**
			 * Remove Html
			 */
			removeHTML: function (value) {
				let regex = /(<([^>]+)>)/ig
				return value.replace(regex, '')
			},

			/**
			 * Set MainHeadline position cross Safari, Firefox, Chrome
			 */
			handleMainTitlePosition () {
				const mainTitle = document.getElementById('main-title')

				if (isChrome) {
					if (isIOS) {
						mainTitle.style.top = '-5%'
					} else if (isAndroid) {
						mainTitle.style.top = '-22%'
					} else {
						mainTitle.style.top = '0%'
					}
				}

				if (isFirefox) {
					if (isIOS) {
						mainTitle.style.top = '-5%'
					} else {
						mainTitle.style.top = '0%'
					}
				}

				if (isSafari) {
					if (isIOS) {
						mainTitle.style.top = '-4%'
					} else {
						mainTitle.style.top = '0%'
					}
				}
			},

			handleLogoPosition () {
				const logoText = this.removeHtmlMethod(this.item.logo)
				const logoLength = logoText.length

				if (isSafari) {
					if (logoLength === 1) {
						this.setLogoTop('0', '25%')
					} else if (logoLength === 2) {
						this.setLogoTop('0', '0')
					} else if (logoLength === 3) {
						this.setLogoTop('1%', '2%')
					} else if (logoLength === 4) {
						this.setLogoTop('1%', '2%')
					}
				}

				if (isFirefox) {
					if (logoLength === 1) {
						this.setLogoTop('-5%', '20%')
					} else if (logoLength === 2) {
						this.setLogoTop('-5%', '-5%')
					} else if (logoLength === 3) {
						this.setLogoTop('-3%', '-1%')
					} else if (logoLength === 4) {
						this.setLogoTop('-3%', '0')
					}
				}

				if (isChrome) {
					if (logoLength === 1) {
						if (isIOS) {
							this.setLogoTop('1%', '25%')
						} else {
							this.setLogoTop('-9%', '16%')
						}
					} else if (logoLength === 2) {
						if (isIOS) {
							this.setLogoTop('1%', '1%')
						} else {
							this.setLogoTop('-9%', '-9%')
						}

					} else if (logoLength === 3) {
						if (isIOS) {
							this.setLogoTop('1%', '2%')
						} else {
							this.setLogoTop('-9%', '-3%')
						}
					} else if (logoLength === 4) {
						if (isIOS) {
							this.setLogoTop('1%', '2%')
						} else {
							this.setLogoTop('-9%', '-4%')
						}
					}
				}
			},

			/**
			 * Set logo position
			 */
			setLogoTop (leftPercent, rightPercent) {
				document.getElementById('logoLeftHeader').style.top = leftPercent
				document.getElementById('logoRightHeader').style.top = rightPercent
			},

			/**
			 * Set Sub Headline before render to image
			 */
			handleSubHeadline () {
				const subHeadline = document.getElementById('sleeve_title')

				if (isChrome) {
					if (isIOS) {
						subHeadline.style.top = '1.3%'
					} else {
						subHeadline.style.top = '-0.8%'
					}
				}

				if (isFirefox) {
					//Check main title length
					subHeadline.style.top = '1.3%'
				}

				if (isSafari) {
					//Check main title length
					subHeadline.style.top = '1.5%'
				}
			},

			/**
			 * Special Character For Mobile Rendering
			 */
			handleSpecialCharacterForMobile () {
				this.replaceSectionString('content')
				this.replaceSectionString('lead_sentence')
				this.replaceSectionString('article_title')
				this.replaceSectionString('sleeve_title')
			},

			/**
			 * add class to Special Character
			 */
			replaceSectionString (field) {
				const androidClass = isAndroid ? ' mr-ar-0' : ''
				const androidClassFlip = isAndroid ? ' ar-flip' : ' flip'
				const androidClassFlip180 = isAndroid ? ' ar-flip180' : ' flip180'
				const androidClassSquareSign = isAndroid ? ' ar-mr-5' : ' mr-5'
				const androidClassRotate90 = isAndroid ? ' ar-rotate90' : ' rotate90'

				this.item[field] = _.replace(this.item[field], /。/g, `<span class="special-dot">。</span>`)
				this.item[field] = _.replace(this.item[field], /．/g, `<span class="special-dot special-dot--small">．</span>`)
				this.item[field] = _.replace(this.item[field], /\./g, `<span class="special-dot special-dot--center">.</span>`)
				this.item[field] = _.replace(this.item[field], /、/g, `<span class="special-comma">、</span>`)
				this.item[field] = _.replace(this.item[field], /【/g, `<span class="special-left${ androidClass }">【</span>`)
				this.item[field] = _.replace(this.item[field], /】/g, `<span class="special-right${ androidClass }">】</span>`)
				this.item[field] = _.replace(this.item[field], /『/g, `<span class="special-left${ androidClass }">『</span>`)
				this.item[field] = _.replace(this.item[field], /』/g, `<span class="special-right${ androidClass }">』</span>`)
				this.item[field] = _.replace(this.item[field], /〈/g, `<span class="special-left${ androidClass }">〈</span>`)
				this.item[field] = _.replace(this.item[field], /〉/g, `<span class="special-right${ androidClass }">〉</span>`)
				this.item[field] = _.replace(this.item[field], /《/g, `<span class="special-left${ androidClass }">《</span>`)
				this.item[field] = _.replace(this.item[field], /》/g, `<span class="special-right${ androidClass }">》</span>`)
				this.item[field] = _.replace(this.item[field], /｛/g, `<span class="special-left${ androidClass }">｛</span>`)
				this.item[field] = _.replace(this.item[field], /｝/g, `<span class="special-right${ androidClass }">｝</span>`)

				this.item[field] = _.replace(this.item[field], /（/g, `<span class="special-left${ androidClass }">（</span>`)
				this.item[field] = _.replace(this.item[field], /）/g, `<span class="special-right${ androidClass }">）</span>`)
				this.item[field] = _.replace(this.item[field], /〜/g,
						`<span class="special-left ml-5${ androidClass }${ androidClassFlip }">〜</span>`)
				this.item[field] = _.replace(this.item[field], /～/g,
						`<span class="special-left ml-5${ androidClass }${ androidClassFlip }">～</span>`)
				this.item[field] = _.replace(this.item[field], /…/g,
						`<span class="special-left ml-5${ androidClass }">…</span>`)
				this.item[field] = _.replace(this.item[field], /＝/g,
						`<span class="special-left ml-5${ androidClass }">＝</span>`)
				this.item[field] = _.replace(this.item[field], /「/g,
						`<span class="special-left${ androidClassSquareSign }${ androidClass }">「</span>`)
				this.item[field] = _.replace(this.item[field], /」/g,
						`<span class="special-right${ androidClassSquareSign }${ androidClass }">」</span>`)
				this.item[field] = _.replace(this.item[field], /ー/g,
						`<span class="special-left ml-5${ androidClassFlip180 }">ー</span>`)
				this.item[field] = _.replace(this.item[field], /―/g,
						`<span class="special-left ml-5${ androidClassFlip180 }${ androidClassRotate90 }">―</span>`)
				this.item[field] = _.replace(this.item[field], /－/g,
						`<span class="special-left ml-5 ${ androidClassFlip180 }">－</span>`)
				this.item[field] = _.replace(this.item[field], /−/g, `<span class="special-left ml-5 hyphen-center">−</span>`)

				this.item[field] = _.replace(this.item[field], /\(/g, `<span class="special-left mr-0">(</span>`)
				this.item[field] = _.replace(this.item[field], /\)/g, `<span class="special-right mr-0">)</span>`)
				this.item[field] = _.replace(this.item[field], /？/g, `<span>？</span>`)
				this.item[field] = _.replace(this.item[field], /！/g, `<span>！</span>`)
				this.item[field] = _.replace(this.item[field], /・/g, `<span>・</span>`)
				this.item.$save()
			},

			/**
			 * Remove class special Character
			 */
			removeSectionString (field) {
				this.item[field] = _.replace(this.item[field], /<span class="special-dot">。<\/span>/g, `。`)
				this.item[field] = _.replace(this.item[field], /<span class="special-dot special-dot--small">．<\/span>/g, `．`)
				this.item[field] = _.replace(this.item[field], /<span class="special-dot special-dot--center">.<\/span>/g, `\.`)
				this.item[field] = _.replace(this.item[field], /<span class="special-comma">、<\/span>/g, `、`)

				//Check on Android phone
				if (isAndroid) {
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">【<\/span>/g, `【`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">】<\/span>/g, `】`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">『<\/span>/g, `『`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">』<\/span>/g, `』`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">〈<\/span>/g, `〈`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">〉<\/span>/g, `〉`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">《<\/span>/g, `《`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">》<\/span>/g, `》`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">｛<\/span>/g, `｛`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">｝<\/span>/g, `｝`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-ar-0">（<\/span>/g, `（`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-ar-0">）<\/span>/g, `）`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ar-mr-5 mr-ar-0">「<\/span>/g, `「`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right ar-mr-5 mr-ar-0">」<\/span>/g, `」`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 mr-ar-0 ar-flip">〜<\/span>/g,
							`〜`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 mr-ar-0 ar-flip">～<\/span>/g,
							`～`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 mr-ar-0">…<\/span>/g, `…`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 mr-ar-0">＝<\/span>/g, `＝`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 ar-flip180">ー<\/span>/g, `ー`)
					this.item[field] = _.replace(this.item[field],
							/<span class="special-left ml-5 ar-flip180 ar-rotate90">―<\/span>/g, `―`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 ar-flip180">－<\/span>/g, `－`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 hyphen-center">−<\/span>/g,
							`−`)

				} else {
					this.item[field] = _.replace(this.item[field], /<span class="special-left">【<\/span>/g, `【`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">】<\/span>/g, `】`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left">『<\/span>/g, `『`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">』<\/span>/g, `』`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left">〈<\/span>/g, `〈`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">〉<\/span>/g, `〉`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left">《<\/span>/g, `《`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">》<\/span>/g, `》`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left">｛<\/span>/g, `｛`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">｝<\/span>/g, `｝`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left">（<\/span>/g, `（`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right">）<\/span>/g, `）`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left mr-5">「<\/span>/g, `「`)
					this.item[field] = _.replace(this.item[field], /<span class="special-right mr-5">」<\/span>/g, `」`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 flip">〜<\/span>/g, `〜`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 flip">～<\/span>/g, `～`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5">…<\/span>/g, `…`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5">＝<\/span>/g, `＝`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 flip180">ー<\/span>/g, `ー`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 flip180 rotate90">―<\/span>/g,
							`―`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 flip180">－<\/span>/g, `－`)
					this.item[field] = _.replace(this.item[field], /<span class="special-left ml-5 hyphen-center">−<\/span>/g,
							`−`)

				}
				this.item[field] = _.replace(this.item[field], /<span class="special-left mr-0">\(<\/span>/g, `(`)
				this.item[field] = _.replace(this.item[field], /<span class="special-right mr-0">\)<\/span>/g, `)`)
				this.item[field] = _.replace(this.item[field], /<span>？<\/span>/g, `？`)
				this.item[field] = _.replace(this.item[field], /<span>！<\/span>/g, `！`)
				this.item[field] = _.replace(this.item[field], /<span>・<\/span>/g, `・`)

				this.item.$save()
			},

			removeHtmlMethod (value) {
				let regex = /(<([^>]+)>)/ig
				return value.replace(regex, '')
			}
		},

		/**
		 * Filter section
		 */
		filters: {
			removeHTML: function (value) {
				let regex = /(<([^>]+)>)/ig
				return value.replace(regex, '')
			},

			/**
			 * @return {string}
			 */
			Upper (value) {
				return value.toUpperCase()
			}
		}
	}
</script>

<style scoped lang="scss" crossorigin="anonymous">
	.container {
		.preview {
			.layout-header {
				margin-bottom: 35px;

				&-date, &-info {
					background: #F2F4F3 url('../../assets/img/bg-header.png');
				}
			}
		}
	}

	.share {
		margin-bottom: 45px;
	}

	.loading {
		position: fixed;
		width: 100%;
		height: 100%;
		text-align: center;
		background: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		opacity: 0;
		z-index: -1;

		&__inner {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			text-align: center;

			&--line {
				width: 100%;
				height: 4px;
				position: fixed;
				top: 0;
				left: 0;
				right: 0;
				margin: auto;
				border-radius: 4px;
				background-size: 20%;
				background: rgba(200, 200, 200, 0.2) linear-gradient(to right, #0088CC, #0088CC) repeat-y -25% 0;
				animation: scroll 1.0s ease-in-out infinite;
			}
		}

		&__spinner {
			animation: rotator 1.4s linear infinite;

			& .path {
				stroke-dasharray: 187;
				stroke-dashoffset: 0;
				stroke: #0088CC;
				transform-origin: center;
				animation: dash 1.4s ease-in-out infinite;
			}
		}

		@keyframes rotator {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(270deg);
			}
		}
		@keyframes dash {
			0% {
				stroke-dashoffset: 187;
			}
			50% {
				stroke-dashoffset: 46.75;
				transform: rotate(135deg);
			}
			100% {
				stroke-dashoffset: 187;
				transform: rotate(450deg);
			}
		}
		@keyframes scroll {
			50% {
				background-size: 80%;
			}
			100% {
				background-position: 125% 0;
			}
		}
	}

	.loading.active {
		/*animation: show 0.2s ease 1s infinite;*/
		opacity: 1;
		z-index: 100;
	}

	@keyframes show {

		100% {
			opacity: 1;
		}
	}

	#button {
		a {
			position: relative;
		}
	}

	.loader {
		width: 20px;
		position: absolute;
		left: 5%;
		top: 50%;
		transform: translateY(-50%);
	}
</style>
